import { useEffect, useRef, useState } from "react";
import useDebounce from "../hooks/useDebounce";

import styles from "./Table.module.css";

import searchClose from "../icons/close.svg";

const TableSearch = ({ onSearchChange, column, focus, searchValue = "" }) => {
  const [search, setSearch] = useState(searchValue);

  const searchContainer = useRef(null);

  const searchInput = useRef(null);

  const debouncedSearch = useDebounce(search);

  const isFirstRender = useRef(true); // track first render

  useEffect(() => {
    const width = searchContainer.current.offsetWidth;
    searchInput.current.style.display = "block";
    searchContainer.current.style.width = `${width}px`;
  }, []);

  useEffect(() => {
    if (isFirstRender.current) 
    {
      isFirstRender.current = false; // skip the first run
      return;
    }
    onSearchChange(column, debouncedSearch);
  }, [column, debouncedSearch, onSearchChange]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const width = searchContainer.current.offsetWidth;
    searchInput.current.style.display = "block";
    searchContainer.current.style.width = `${width}px`;

    if (focus && searchInput.current) 
    {
      searchInput.current.focus();
    }
  }, [focus]);

  return (
    <div ref={searchContainer} className={styles.searchContainer}>
      <input
        ref={searchInput}
        type="search"
        value={search}
        onChange={handleSearchChange}
        className={[styles.search, search && styles.searchBorder].join(" ")}
        style={{ display: "none" }}
        {...(focus ? { autoFocus: true } : {})}
      />
      <button style={{ display: "contents" }} onClick={() => setSearch("")}>
        <img
          src={searchClose}
          alt="search"
          className={[
            styles.searchCloseIcon,
            search && styles.searchCloseIconVisible,
          ].join(" ")}
        />
      </button>
    </div>
  );
};

export default TableSearch;
